import type { FC } from 'react';

import { useSession } from '@eneco/auth';
import env from '@eneco/common/env';
import { NavLink } from '@eneco/sparky';
import { LogoutIcon } from '@eneco/sparky/icons';
import { signOut } from 'next-auth/react';

export const LogoutButton: FC<Props> = ({ label = 'Uitloggen' }) => {
  const { data: session } = useSession() ?? {};

  if (session) {
    const oktaSignoutUrl = `${env('OKTA_OAUTH2_LOGOUT')}?id_token_hint=${
      session.idToken
    }&post_logout_redirect_uri=${env('OKTA_OAUTH2_LOGOUT_REDIRECT_URI')}`;

    return (
      <NavLink
        variant="secondary"
        onClick={() => {
          signOut({ redirect: false }).then(() => (window.location.href = oktaSignoutUrl));
        }}
        leftIcon={<LogoutIcon />}>
        {label}
      </NavLink>
    );
  }

  return null;
};

interface Props {
  label?: string;
}
